<template>
  <div :qaid="`${componentPrefix}`">
    <div v-if="hasVideo" :qaid="`${componentPrefix}-video`" class="features-set__slide">
      <article class="features-set__slide__video">
        <a
          :href="primaryFeature.video.url"
          class="play-icon-after"
          data-video
          data-ga-event="video-engagement"
          data-ga-category="Video Engagement"
          :data-ga-action="primaryFeature.video.caption"
          data-ga-label="Play"
        >
          <image-component
            :qaid="`${componentPrefix}-image`"
            :asset-id="primaryFeature.video.stillAssetId"
            :alt-text="getAltText"
          />
        </a>
        <div class="px-2 mt-1 mb-3 lg:mb-2">
          <pdl-heading :qaid="`${componentPrefix}-heading`" :level="3" size="md">
            {{ primaryFeature.video.caption }}
          </pdl-heading>
        </div>
      </article>
    </div>

    <template v-if="hasSubFeatures">
      <sub-feature
        v-for="(subFeature, index) in primaryFeature.subFeatures"
        :key="`subfeature-${index}`"
        :sub-feature="subFeature"
      />
    </template>
  </div>
</template>

<script>
import ImageComponent from '@/components/ImageComponent.vue';
import {PdlHeading} from '@pedal/pdl-section-header';
import SubFeature from '@/components/tabs/features/SubFeature.vue';

export default {
  components: {
    ImageComponent,
    PdlHeading,
    SubFeature,
  },
  props: {
    primaryFeature: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentPrefix: 'primary-feature',
    };
  },
  computed: {
    hasVideo() {
      return this.primaryFeature?.video;
    },
    hasSubFeatures() {
      return !!this.primaryFeature?.subFeatures;
    },
    getAltText() {
      return this.primaryFeature?.video?.caption;
    },
  },
};
</script>

<style lang="scss" scoped>
.features-set {
  &__slide {
    &__video {
      position: relative;

      .play-icon-after {
        display: block;
        position: relative;

        &::after {
          position: absolute;
          font-size: rem-calc(50px);
          text-decoration: none;
          color: var(--white);
          opacity: 0.8;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
